import React from 'react'
import Layout from '../../components/help/Layout/Layout'
import Seo from '../../components/help/Seo'
import Header from '../../components/ui/Header/Header'
import Intro from '../../components/ui/Intro/Intro'
import Projects from '../../components/pages/Projects/Projects'
import { getHrefToHome } from '../../utils/getHrefToHome'
import { useStaticQuery, graphql } from 'gatsby'

const ProjectsPage = () => {
    const lang = 'hy'
    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageProject(title: { eq: "Title" }, locale: { eq: "hy" }) {
                value
            }

            text: datoCmsRenshinPageProject(title: { eq: "Text" }, locale: { eq: "hy" }) {
                value
            }

            location: datoCmsRenshinPageProject(title: { eq: "Text: Location" }, locale: { eq: "hy" }) {
                value
            }

            items: allDatoCmsRenshinProject(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    title
                    previewText
                    location
                    urlCode
                    previewPictureDesktop {
                        url
                    }
                }
            }

            seo: datoCmsRenshinSeo(originalId: { eq: "114097366" }, locale: { eq: "hy" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(originalId: { eq: "114097337" }, locale: { eq: "hy" }) {
                crumbsName
            }
        }
    `)

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    const photo = {
        1920: data.seo.bgDesktop.url,
        1440: data.seo.bgDesktop.url,
        1024: data.seo.bgTabletA?.url,
        768: data.seo.bgTabletP?.url,
        360: data.seo.bgMobile?.url
    }

    return (
        <Layout lang={lang}>
            <Seo
                title={data.seo.seo && data.seo.seo.title ? data.seo.seo.title : ''}
                description={data.seo.seo && data.seo.seo.description ? data.seo.seo.description : ''}
            />

            <Header light lang={lang} />

            <Intro crumbs={breadCrumbs} title={`${data.seo.titleH1}`} photo={photo} lang={lang} />

            <Projects
                data={data}
                lang={lang}
                textLocation={data.location && data.location.value ? data.location.value : false}
            />
        </Layout>
    )
}

export default ProjectsPage
